<template>
  <v-container>
    <back-btn />
    <v-row>
      <v-col lg="12">
        <v-card class="card--shadow">
          <v-card-text>
            <div v-if="patient" class="d-flex mb-2">
              <p v-if="patient.name" class="subtitle-1 patient-info">
                Name - {{ patient.name }}
              </p>
              <p
                v-if="patient.treatment_startdate != null"
                class="ml-3 subtitle-1 patient-info"
              >
                Code - {{ patient.reg_unique_code }}
              </p>
            </div>
            <div v-if="eachFamilyMember && eachFamilyMember.id" class="d-flex mb-2">
              <p v-if="patient.name" class="subtitle-1 patient-info">
              Family Member Name - <strong> {{ eachFamilyMember.name }}</strong>
              </p>
            </div>
            <v-data-table
              v-if="Array.isArray(familyMemberCi) && familyMemberCi.length"
              :headers="tbHeaders"
              :items="familyMemberCi"
              :items-per-page="itemsPerPage"
              @page-count="pageCount = $event"
              :page.sync="page"
              item-key="id"
              hide-default-footer
              hide-default-header
            >
              <template v-slot:header="{ props: { headers } }">
                <thead class="header">
                  <tr>
                    <th v-for="header in headers" :key="header.text" class="header--text">
                      <span v-if="header.value">{{ header.text }}</span>
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:item="{ index, item }">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ item.type=='1'?'Community':'Contact' }}</td>
                  <td>{{ item.screening_person=='1'?'Volunteer':'FO'}}</td>
                  <td>{{ item.symptom_screening=='1'?'No':'Yes' }}</td>
                  <td>{{ item.refer=='1'?'No':'Yes' }}</td>
                </tr>
              </template>
            </v-data-table>
            <div v-if="Array.isArray(familyMemberCi) && familyMemberCi.length" class="text-center py-3">
              <v-pagination color="purple accent-4" v-model="page" :length="pageCount"></v-pagination>
            </div>
            <div v-else class="text-center py-4">
              No CI records found.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    BackBtn
  },
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    tbHeaders: [
      { text: "No", value: "no" },
      { text: "Date", value: "date" },
      { text: "Type", value: "type" },
      { text: "Screening Person", value: "screening_person" },
      { text: "Symptom Screening", value: "symptom_screening" },
      { text: "Refer", value: "refer" }
    ]
  }),
  created() {
    this.$store.dispatch("FamilyMember/getEachCi", this.$route.params.id);
    this.$store.dispatch("FamilyMember/getEach", this.$route.params.id).then(() => {
      if (this.eachFamilyMember && this.eachFamilyMember.patient_id) {
        this.$store.dispatch("Patient/getPatient", this.eachFamilyMember.patient_id);
      }
    });
  },
  computed: {
    ...mapState("FamilyMember", ["familyMemberCi"]),
    ...mapGetters("FamilyMember", ["eachFamilyMember"]),
    ...mapState("Patient", ["patient"])
  }
};
</script>

<style scoped>
.patient-info {
  letter-spacing: 1px !important;
}
</style>
